import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Link as CambridgeLink,
} from '@cambridgeassessment/cambridge-ui';
import { Button } from '@cambridgeassessment/cambridge-ui/build/components/Button';
import { Box, Container, Typography } from '@material-ui/core';
import React, { memo, useCallback } from 'react';
import { hot } from 'react-hot-loader/root';
import { Link } from 'react-router-dom';
import { EMAIL_GDPR } from 'src/constants';
import { useAppContext } from '../AppContext';
import { account } from './constants';
import { useAccountStyles } from './styles';

const AccountPage: React.FC = () => {
  const classes = useAccountStyles();
  const { setAppState } = useAppContext();

  const handleClick = useCallback((e) => {
    setAppState((prevState) => ({
      ...prevState,
      currentPage: e.target.textContent + '_' + Date.now(),
    }));
  }, []);

  return (
    <Container disableGutters maxWidth="xl">
      <Box mb={4}>
        <Typography variant="h2">My account</Typography>
      </Box>
      <Box display="flex" flexWrap="wrap">
        {account.navigationCards.map(
          ({ title, description, buttonText, path }) => (
            <Card key={title} className={classes.card}>
              <CardContent>
                <CardHeader title={title} />
                <Box>
                  <Typography variant="body1" className={classes.SizeFix}>
                    {description}
                  </Typography>
                </Box>
              </CardContent>
              <CardActions>
                <Button
                  className={classes.LinkColor}
                  component={Link}
                  to={path}
                  size="large"
                  color="primary"
                  variant="text"
                  onClick={handleClick}
                  data-testid="card-link"
                >
                  {buttonText}
                </Button>
              </CardActions>
            </Card>
          )
        )}
      </Box>
      <Box my={3} width="80%">
        <Typography variant="body1" className={classes.SizeFix}>
          If you have a privacy or data protection enquiry, including an enquiry
          related to GDPR (General Data Protection Regulation), or deleting your
          account,{' '}
          <CambridgeLink
            className={classes.LinkColor}
            href={`mailto:${EMAIL_GDPR}`}
          >
            contact our GDPR team
          </CambridgeLink>
          .
        </Typography>
      </Box>
    </Container>
  );
};

export default hot(memo(AccountPage));
